import { useCallback, useEffect } from "react";
import { useWindow } from "./useWindow";
import { useDocument } from "./useDocument";
export const useRecaptcha = ({ isV3, siteKey }) => {
    const renderQuery = `?render=${siteKey}`;
    const baseRecaptchaUrl = `https://www.google.com/recaptcha/api.js${isV3 ? renderQuery : ""}`;
    const myDocument = useDocument();
    const myWindow = useWindow();
    const getToken = useCallback(() => {
        if (!myWindow) {
            return;
        }
        if (isV3) {
            return new Promise((resolve) => myWindow.grecaptcha.ready((_) => myWindow.grecaptcha.execute(siteKey, { action: "homepage" }).then((recaptchaToken) => resolve(recaptchaToken))));
        }
        else {
            return myWindow.grecaptcha.getResponse();
        }
    }, [myWindow]);
    useEffect(() => {
        if (!!myDocument) {
            const script = myDocument.createElement("script");
            script.src = baseRecaptchaUrl;
            myDocument.body.appendChild(script);
        }
    }, [myDocument]);
    return {
        getToken
    };
};
